<template>
  <div class="headContainer">
    <div style="width: 80px;"></div>
    <div v-for="(course,index) in courseList">
      <div class="title" @click="changeCourse(course.course_id,index)">
        {{course.courseName}}
      </div>
      <div v-if="course.isChoose" style="background-color: #90caf9fa;height: 6px;margin-top: 5px;"></div>
    </div>

    <!--      <div >-->
    <!--        <input placeholder="输入关键字" class="input">-->
    <!--      </div>-->
  </div>
</template>

<script>

  import {EventBus} from  '../utils/event-bus';
  export default {
    name: "Header",
    data:function () {
      return{
        courseList:[
          {courseName:'我的课程',course_id:'1',isChoose:true},
          {courseName:'热门课程',course_id:'2',isChoose: false},
          {courseName:'更多课程',course_id:'3',isChoose: false},
          // {courseName:'幼小衔接',course_id:'4',isChoose: false},
        ]
      }
    },
    methods:{
      changeCourse(course_id,index){
        //发送事件
        EventBus.$emit('changeCourse',{course_id:course_id});

        //改变下方的定位条
        let _self =this;
        for(let i=0;i<_self.courseList.length;i++){
          _self.courseList[i].isChoose=false;
        }
        _self.courseList[index].isChoose=true;

      } ,
    },
  }
</script>

<style scoped>
  @import "../assets/fonts/font.css";
  .headContainer{
    position: fixed;
    top: 0;
    background-color: #ffffff;
    width: 100%;
    height: 40px;
    display: flex;
    border-bottom: #00000038 solid 1px;
  }
  .title{
    padding-top: 12px;
    padding-left: 20px;
    padding-right: 20px;
    font-family: myMind;
    cursor: pointer;
  }
  .input{
    position: fixed;
    right: 50px;
    border-radius: 28px;
    width: 150px;
    height: 30px;
    margin-top: 6px;
    font-family: myMind;
    text-align: center;
    outline: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/Header.vue